// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i21X","footer":"styles_footer__nyGN6","passCodeTooltip":"styles_passCodeTooltip__1foTR"};